import moment from "moment";
import DynamicDateComponent from "../../components/report/dynamic-date.component";
import DynamicReportFilterComponent from "../../components/report/dynamic-report-filter.component";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import { DATE_TYPE_CODES, formats } from "../../config/constants";
import RawDataModel from "../../models/raw-data/raw-data.model";
import ViewBase from "../view-base.view";

export default function RawDataDownloadView() {
    ViewBase.call(this);

    const FILENAME_DOWNLOAD_DATA = () => `${selectedDataType?.name.replaceAll('.', '_')}_Data_${API_REQUEST_PARAMS.fromDate}_${API_REQUEST_PARAMS.toDate}`;

    const CONFIG_TYPE_DATE = 'DateType';

    const DEFAULT_BASE_FILTERS = {
        periodCode: DATE_TYPE_CODES.DATE,
        fromDate: moment().format(formats.dateFormat),
        toDate: moment().format(formats.dateFormat),
        parameters: []
    };
    let baseFilters = structuredClone(DEFAULT_BASE_FILTERS);

    const API_REQUEST_PARAMS = {
        get periodCode() { return baseFilters.periodCode },
        get fromDate() { return toApiDateFormat(this.periodCode, baseFilters.fromDate) },
        get toDate() { return toApiDateFormat(this.periodCode, baseFilters.toDate) },
        get parameters() {
            return baseFilters.parameters.map(param => {
                let value = '';

                if (typeof param.value === 'boolean') {
                    value = param.value.toString();
                } else if (Array.isArray(param.value)) {
                    if (typeof param.value[0] === 'object') {
                        value = param.value.map(element => element.code).join('^');
                    } else {
                        value = param.value.join('^');
                    }
                } else if (typeof param.value === 'object') {
                    value = param.value.code;
                } else {
                    value = param.value;
                }


                return `${param.key}:=${value}`;
            }).join('^^')
        }
    };

    let dataTypes = [];
    let selectedDataType = null;
    let supportedDates = [];

    const getDataTypes = () => {
        dataTypes = [];
        return RawDataModel.getDataTypes('download')
            .then(result => {
                dataTypes = result;
            })
            .catch(error => {
                this.handleError(error)
            });
    }

    const getConfig = () => {
        supportedDates = [];
        return RawDataModel.getConfigs(selectedDataType?.id)
            .then(result => {
                if (result) {
                    for (const config of result) {
                        switch (config.configType) {
                            case CONFIG_TYPE_DATE: {
                                supportedDates = config.value1.split('^');
                                baseFilters.periodCode = supportedDates[0];
                            }
                        }
                    }
                }
            })
            .catch((error) => {
                this.handleError(error);
            });
    }

    const downloadReport = () => {
        this.showLoading();
        let filename = FILENAME_DOWNLOAD_DATA();
        return RawDataModel.downloadRawDataDownloadData(selectedDataType?.id, API_REQUEST_PARAMS, selectedDataType?.location, filename)
            .catch(error => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    }

    const onSearch = (e) => {
        // Form validation
        if (!this.validateForm(e)) {
            return false;
        }

        return downloadReport();
    }

    const FilterWrapperComponent = () => {
        return {
            view: (vnode) => {
                return m('.col-12', vnode.attrs, vnode.children)
            }
        }
    }

    const toApiDateFormat = (dateType, date) => {
        switch (dateType) {
            case DATE_TYPE_CODES.DATE:
                return moment(date).format(formats.apiDateFormat);
            case DATE_TYPE_CODES.WEEK:
                return moment(date).format(formats.API_WEEK_FORMAT);
            case DATE_TYPE_CODES.MONTH:
                return moment(date).format(formats.API_MONTH_FORMAT);
        }
    }

    return {
        oninit: () => {
            getDataTypes();
        },
        view: () => [
            m('.vstack.gap-2',
                m('.card',
                    m('.card-body',
                        m('form.needs-validation[novalidate].row.g-3', { onsubmit: onSearch },
                            m('.col-5.position-relative',
                                m('.vstack.h-100.justify-content-end',
                                    m('label.form-label.mandatory', this.getText('LT00000013', 'Data Type')),
                                    m(SingleSelectComponent, {
                                        required: true,
                                        allowEmpty: false,
                                        itemKey: 'id',
                                        selectedItem: selectedDataType,
                                        items: dataTypes,
                                        onSelect: (selectedItem) => {
                                            selectedDataType = selectedItem;
                                            baseFilters = structuredClone(DEFAULT_BASE_FILTERS);
                                            getConfig();
                                        }
                                    }),
                                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                                )
                            ),
                            m('.col-3',
                                m(DynamicDateComponent, {
                                    selectedDateType: baseFilters.periodCode,
                                    supportedDates,
                                    required: true,
                                    fromDate: baseFilters.fromDate,
                                    toDate: baseFilters.toDate,
                                    onChange: (dateType, fromDate, toDate) => {
                                        baseFilters.periodCode = dateType;
                                        baseFilters.fromDate = fromDate;
                                        baseFilters.toDate = toDate;
                                    }
                                })
                            ),
                            m('.col-5',
                                m('.row.g-3',
                                    m(DynamicReportFilterComponent, {
                                        filterWrapperComponent: FilterWrapperComponent,
                                        buttonWrapperComponent: FilterWrapperComponent,
                                        isRawData: true,
                                        data: {
                                            dataTypeId: selectedDataType?.id,
                                            parameters: baseFilters.parameters,
                                            location: selectedDataType?.location
                                        },
                                        onChange: (data) => {
                                            baseFilters.parameters = data;
                                        }
                                    })
                                )
                            ),
                            m('.col-12.hstack.justify-content-end',
                                m('button.btn.btn-primary', { disabled: selectedDataType === null }, this.getText('LT00000492', 'Download'))
                            )
                        )
                    )
                )
            ),
            this.getBaseViews()
        ]
    }
}